export default __webpack_public_path__ + "static/media/Bell.888b84c9.svg";